import { render } from "./pic-pane.vue?vue&type=template&id=f0577e4c&scoped=true&ts=true"
import script from "./pic-pane.vue?vue&type=script&lang=ts"
export * from "./pic-pane.vue?vue&type=script&lang=ts"

import "./pic-pane.vue?vue&type=style&index=0&id=f0577e4c&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0577e4c"]])

export default __exports__